module.exports = __webpack_public_path__ + "media/images/mstile-150x150-036fc1ce9557ac49a46c3c0f94b917dc.png";